import React, { useState, useEffect } from 'react';
import apiService from '../services/apiService';

function AdminTestimonials() {
  const [testimonials, setTestimonials] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingTestimonial, setEditingTestimonial] = useState(null);
  const [formData, setFormData] = useState({
    customer_name: '',
    content: '',
    location: '',
    rating: 5,
    is_featured: false,
    is_approved: true
  });
  const token = localStorage.getItem('token');

  useEffect(() => {
    loadTestimonials();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadTestimonials = () => {
    apiService.getTestimonials(false, token)
      .then(response => setTestimonials(response.data.testimonials))
      .catch(error => console.error('Error loading testimonials:', error));
  };

  const handleAdd = () => {
    setEditingTestimonial(null);
    setFormData({
      customer_name: '',
      content: '',
      location: '',
      rating: 5,
      is_featured: false,
      is_approved: true
    });
    setShowForm(true);
  };

  const handleEdit = (testimonial) => {
    setEditingTestimonial(testimonial);
    setFormData({
      customer_name: testimonial.customer_name || '',
      content: testimonial.content || '',
      location: testimonial.location || '',
      rating: testimonial.rating || 5,
      is_featured: testimonial.is_featured ? true : false,
      is_approved: testimonial.is_approved ? true : false
    });
    setShowForm(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (editingTestimonial) {
      // Update existing
      const updateData = {
        ...formData,
        id: editingTestimonial.id
      };
      
      apiService.updateTestimonial(updateData, token)
        .then(() => {
          loadTestimonials();
          setShowForm(false);
          setEditingTestimonial(null);
        })
        .catch(error => {
          console.error('Error updating testimonial:', error);
          alert('Failed to update testimonial. Please try again.');
        });
    } else {
      // Create new
      apiService.addTestimonial(formData, token)
        .then(() => {
          loadTestimonials();
          setShowForm(false);
          setFormData({
            customer_name: '',
            content: '',
            location: '',
            rating: 5,
            is_featured: false,
            is_approved: true
          });
        })
        .catch(error => {
          console.error('Error adding testimonial:', error);
          alert('Failed to add testimonial. Please try again.');
        });
    }
  };

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this testimonial?')) {
      apiService.deleteTestimonial(id, token)
        .then(() => loadTestimonials())
        .catch(error => {
          console.error('Error deleting testimonial:', error);
          alert('Failed to delete testimonial. Please try again.');
        });
    }
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingTestimonial(null);
    setFormData({
      customer_name: '',
      content: '',
      location: '',
      rating: 5,
      is_featured: false,
      is_approved: true
    });
  };

  return (
    <div>
      <h2>Testimonial Management</h2>
      
      <button className="btn-admin btn-add" onClick={handleAdd}>
        + Add New Testimonial
      </button>

      {showForm && (
        <div className="modal-overlay" onClick={handleCancel}>
          <div className="modal-content admin-form" onClick={(e) => e.stopPropagation()}>
            <h3>{editingTestimonial ? 'Edit Testimonial' : 'Add New Testimonial'}</h3>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Customer Name *</label>
                <input
                  type="text"
                  value={formData.customer_name}
                  onChange={(e) => setFormData({ ...formData, customer_name: e.target.value })}
                  required
                />
              </div>

              <div className="form-group">
                <label>Content *</label>
                <textarea
                  value={formData.content}
                  onChange={(e) => setFormData({ ...formData, content: e.target.value })}
                  required
                  rows="5"
                />
              </div>

              <div className="form-group">
                <label>Title</label>
                <input
                  type="text"
                  value={formData.location}
                  onChange={(e) => setFormData({ ...formData, location: e.target.value })}
                  placeholder="Testimonial title"
                />
              </div>

              <div className="form-group">
                <label>Rating *</label>
                <select
                  value={formData.rating}
                  onChange={(e) => setFormData({ ...formData, rating: parseInt(e.target.value) })}
                  required
                >
                  <option value={1}>1/5</option>
                  <option value={2}>2/5</option>
                  <option value={3}>3/5</option>
                  <option value={4}>4/5</option>
                  <option value={5}>5/5</option>
                </select>
              </div>

              <div className="form-group">
                <label>
                  <input
                    type="checkbox"
                    checked={formData.is_featured}
                    onChange={(e) => setFormData({ ...formData, is_featured: e.target.checked })}
                  />
                  Featured
                </label>
              </div>

              <div className="form-group">
                <label>
                  <input
                    type="checkbox"
                    checked={formData.is_approved}
                    onChange={(e) => setFormData({ ...formData, is_approved: e.target.checked })}
                  />
                  Approved
                </label>
              </div>

              <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
                <button type="submit" className="btn-save">
                  {editingTestimonial ? 'Update' : 'Add'} Testimonial
                </button>
                <button type="button" className="btn-admin btn-delete" onClick={handleCancel}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      
      <div className="admin-card">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Customer</th>
              <th>Content</th>
              <th>Title</th>
              <th>Rating</th>
              <th>Featured</th>
              <th>Approved</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {testimonials.length === 0 ? (
              <tr>
                <td colSpan="7" style={{ textAlign: 'center', padding: '40px' }}>
                  No testimonials found. Click "Add New Testimonial" to create one.
                </td>
              </tr>
            ) : (
              testimonials.map(testimonial => (
                <tr key={testimonial.id}>
                  <td>{testimonial.customer_name}</td>
                  <td style={{maxWidth: '300px', wordWrap: 'break-word'}}>
                    {testimonial.content.length > 100 
                      ? `${testimonial.content.substring(0, 100)}...` 
                      : testimonial.content}
                  </td>
                  <td>{testimonial.location || '-'}</td>
                  <td>{testimonial.rating}/5</td>
                  <td>{testimonial.is_featured ? 'Yes' : 'No'}</td>
                  <td>{testimonial.is_approved ? 'Yes' : 'No'}</td>
                  <td>
                    <button 
                      className="btn-admin btn-edit" 
                      onClick={() => handleEdit(testimonial)}
                      style={{ marginRight: '10px' }}
                    >
                      Edit
                    </button>
                    <button 
                      className="btn-admin btn-delete" 
                      onClick={() => handleDelete(testimonial.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AdminTestimonials;
